import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "h-full w-[427px] bg-brown overflow-y-auto no-scrollbar hidden lg:block" }
const _hoisted_2 = { class: "pt-8 pl-8 pb-[17px] border-b border-white border-opacity-20" }
const _hoisted_3 = { class: "font-semibold text-xl leading-[28px] text-muted text-left" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "font-medium text-base leading-[24px] text-white pl-4 group-hover:underline" }


import { ActivationGroup } from "@/types/calculators";
import { activationGroups } from "@/constants/activations";
import { useI18n } from "vue-i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'BackSidebar',
  props: {
    selectedActivation: {}
  },
  emits: ["changeActivationGroup"],
  setup(__props: any) {




const { t } = useI18n();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(t)("calculators.activations.another_activations")), 1)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(activationGroups), (activationGroup) => {
      return (_openBlock(), _createElementBlock("div", {
        key: activationGroup.key,
        class: _normalizeClass(["py-4 pl-4 items-center border-b border-white border-opacity-20 hover:bg-white hover:bg-opacity-20 group hover:cursor-pointer", 
        __props.selectedActivation.key === activationGroup.key ? 'hidden' : 'flex'
      ]),
        onClick: ($event: any) => (_ctx.$emit('changeActivationGroup', activationGroup))
      }, [
        _createElementVNode("img", {
          class: "w-[130px] h-[67px] object-center object-cover rounded-lg",
          src: 
          require(`@/assets/calculators/activations/${activationGroup.key}.jpg`)
        ,
          alt: activationGroup.key
        }, null, 8, _hoisted_5),
        _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(t)(`calculators.activations.group.${activationGroup.key}`)), 1)
      ], 10, _hoisted_4))
    }), 128))
  ]))
}
}

})